module.exports = __webpack_public_path__ + "static/media/cookies-policy(4).7f569140.pdf";